module.exports = __webpack_public_path__ + "images/OK_R+2_MAJ_20-09-2021_2-Photocopie.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/OK_R+2_MAJ_20-09-2021_2-Photocopie.jpg
// module id = 43
// module chunks = 0